var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dummypage"}},[_c('p',[_c('b-icon',{attrs:{"icon":"timer-sand-full","size":"is-large"}}),_vm._v("Please wait ...")],1),_c('p',[_vm._v(_vm._s(_vm.$route.path.split('/').pop())+" page will be available soon")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9155c5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dummy.vue
// module id = null
// module chunks = 